module.exports = __webpack_public_path__ + "static/media/shutdown.ec8b8c4d.png";